/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {
  useState,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';
import Ad from 'models/business/Ad';
import classNames from 'classnames';
import useValidateMedia from 'components/hooks/useValidateMedia';
import { Categories as PlatformCategories } from 'models/business/Platform';
import { Categories as AssetCategories } from 'models/business/Asset';
import CarouselPlaceholderImage from 'assets/carousel-placeholder.png';
import NonCarouselPlaceholderImage from 'assets/nonCarousel-placeholder.jpg';
import Styles from './index.module.css';

export default function PhonePreview({
  className,
  ad,
  media,
  ...props
}) {
  const [showViewMore, setShowViewMore] = useState(false);
  const [adPlatform, setAdPlatform] = useState();
  const [adContentFeedCategory, setAdContentFeedCategory] = useState();
  const [showExample, setShowExample] = useState(true);
  const [overflowStyle, setOverflowStyle] = useState();
  const { validateImageName, validateVideoName } = useValidateMedia();
  const [imageSource, setImageSource] = useState('');
  const [videoSource, setVideoSource] = useState('');
  const loadLocalFile = async (file) => {
    const fileReader = new FileReader();
    await new Promise((resolve) => {
      fileReader.onload = resolve;
      fileReader.onerror = resolve;
      fileReader.readAsDataURL(file);
    });

    return fileReader.result || '';
  };

  const AdMainCopyLength = 57;

  const [adMainCopy, setAdMainCopy] = useState(ad.mainCopy.toString());

  // useEffect(() => {
  //   if (adMainCopy !== ad.mainCopy.toString() && ad.mainCopy.length > AdMainCopyLength) {
  //     setAdMainCopy(ad.mainCopy.toString());
  //     setShowViewMore(true);
  //   }
  //   if (ad.mainCopy.length <= AdMainCopyLength) {
  //     setShowViewMore(false);
  //   }
  // });

  const handleClick = (e) => {
    if (showExample) {
      setOverflowStyle({ overflow: 'auto' });
    } else if (ad.mainCopy.length <= AdMainCopyLength && ad.mainCopy.split(/\r\n|\r|\n/).length < 2) {
      setOverflowStyle({ overflow: 'unset' });
    } else {
      setOverflowStyle({ overflow: 'auto' });
    }
    setShowViewMore(false);
    e.preventDefault();
  };

  useEffect(() => {
    let stateChange = false;
    if (adPlatform !== ad.platform) {
      stateChange = true;
    }
    setAdPlatform(ad.platform);

    // 判斷是否顯示範例
    let isShowExmple = false;
    switch (ad.platform) {
      case PlatformCategories.FacebookCarousel:
        if (ad.mainCopy.length === 0) {
          isShowExmple = true;
        }
        break;
      case PlatformCategories.FacebookFeatured:
        if (ad.mainCopy.length === 0
          && ad.title.length === 0
          && ad.description.length === 0
          && !media.local
          && !media.prepopulated) {
          isShowExmple = true;
        }
        break;
      case PlatformCategories.FacebookReferral:
        if (ad.mainCopy.length === 0
          && ad.title.length === 0
          && !media.local
          && !media.prepopulated) {
          isShowExmple = true;
        }
        break;
      case PlatformCategories.FacebookImpression:
        if (ad.mainCopy.length === 0
          && !media.local
          && !media.prepopulated) {
          isShowExmple = true;
        }
        break;
      default:
    }
    setShowExample(isShowExmple);

    // 判斷是否顯示 ViewMore
    let isShowViewMore = showViewMore;
    // console.log(`o isShowViewMore: ${isShowViewMore}`);
    if (stateChange) {
      isShowViewMore = true;
    }
    if (isShowExmple && isShowViewMore) {
      isShowViewMore = true;
    }
    switch (ad.platform) {
      case PlatformCategories.FacebookCarousel:
        if (adMainCopy !== ad.mainCopy.toString()) {
          setAdMainCopy(ad.mainCopy.toString());
        }
        if (isShowExmple || ad.mainCopy.length > AdMainCopyLength || ad.mainCopy.split(/\r\n|\r|\n/).length > 2) {
          isShowViewMore = true;
        } else {
          isShowViewMore = false;
        }
        break;
      case PlatformCategories.FacebookFeatured:
        if (adMainCopy !== ad.mainCopy.toString()) {
          setAdMainCopy(ad.mainCopy.toString());
        }
        if (isShowExmple || ad.mainCopy.length > AdMainCopyLength || ad.mainCopy.split(/\r\n|\r|\n/).length > 2) {
          isShowViewMore = true;
        } else {
          isShowViewMore = false;
        }
        break;
      case PlatformCategories.FacebookReferral:
        if (adMainCopy !== ad.mainCopy.toString()) {
          setAdMainCopy(ad.mainCopy.toString());
        }
        if (isShowExmple || ad.mainCopy.length > AdMainCopyLength || ad.mainCopy.split(/\r\n|\r|\n/).length > 2) {
          isShowViewMore = true;
        } else {
          isShowViewMore = false;
        }
        break;
      case PlatformCategories.FacebookImpression:
        if (adMainCopy !== ad.mainCopy.toString()) {
          setAdMainCopy(ad.mainCopy.toString());
        }
        if (isShowExmple || ad.mainCopy.length > AdMainCopyLength || ad.mainCopy.split(/\r\n|\r|\n/).length > 2) {
          isShowViewMore = true;
        } else {
          isShowViewMore = false;
        }
        break;
      default:
    }

    // if (stateChange || (ad.mainCopy
    //     && adMainCopy !== ad.mainCopy.toString()
    //     && ad.mainCopy.length > AdMainCopyLength)) {
    //   setAdMainCopy(ad.mainCopy.toString());
    //   isShowViewMore = true;
    // }
    // if (ad.mainCopy.length <= AdMainCopyLength) {
    //   isShowViewMore = false;
    // }
    setShowViewMore(isShowViewMore);

    if (isShowViewMore) {
      setOverflowStyle({ overflow: 'unset' });
    }
    if (!isShowExmple && !isShowViewMore) {
      if (ad.mainCopy.length <= AdMainCopyLength && ad.mainCopy.split(/\r\n|\r|\n/).length < 2) {
        setOverflowStyle({ overflow: 'unset' });
      } else {
        setOverflowStyle({ overflow: 'auto' });
      }
    }

    if (ad.platform === PlatformCategories.FacebookCarousel) {
      setImageSource(CarouselPlaceholderImage);
      setVideoSource('');
      return;
    }

    if (media.local) {
      if (validateImageName(media.local.name || '')) {
        loadLocalFile(media.local).then((source) => {
          setImageSource(source);
          setVideoSource('');
        });
      } else if (validateVideoName(media.local.name || '')) {
        loadLocalFile(media.local).then((source) => {
          setVideoSource(source);
          setImageSource('');
        });
      } else {
        setImageSource('');
        setVideoSource('');
      }
    } else if (media.prepopulated) {
      if (validateImageName(media.prepopulated.name || '')) {
        setImageSource(media.prepopulated.url);
        setVideoSource('');
      } else if (validateVideoName(media.prepopulated.name || '')) {
        setVideoSource(media.prepopulated.url);
        setImageSource('');
      } else {
        setImageSource('');
        setVideoSource('');
      }
    } else {
      if (ad.mainCopy.length === 0
        && ad.title.length === 0
        && ad.description.length === 0) {
        setImageSource(NonCarouselPlaceholderImage);
      } else {
        setImageSource('');
      }
      setVideoSource('');
    }
  }, [media, ad]);

  return (
    <div className={classNames(Styles.mainContainer, className)} {...props}>
      <div className={Styles.upperContainer}>
        <div className={Styles.microphone} />
        <div className={Styles.speakerContainer}>
          <div className={Styles.camera} />
          <div className={Styles.speaker} />
        </div>
      </div>
      <div className={Styles.contentContainer}>
        <div className={Styles.contentTopBar} />
        <div className={Styles.contentHeaderBar}>
          <div className={Styles.contentHeaderSquare} />
          <div className={Styles.contentHeaderText}>
            <div className={Styles.contentHeaderTitle}>
              您的賣場粉絲團名稱
            </div>
            <div className={Styles.contentHeaderSubtitle}>
              贊助
            </div>
          </div>
        </div>
        <div className={Styles.contentBody} style={overflowStyle}>
          <div style={{ textAlign: 'left' }}>
            {(showViewMore) && (
              <div className={Styles.contentSubHeaderTitle}>
                {!showExample && ad.mainCopy.substring(0, AdMainCopyLength)}
                {showExample && (`(文案範例預覽)
歡慶新年🎊New Balance品牌週🎊
【勁爆下殺全館５折起🔥】
新年穿新鞋！立刻下單去🛒https://lihi1.com/lxTq9

▼▼熱銷款限時超低價！超多優惠報你知▼▼
✨百搭復古運動鞋 #M5740TA 限搶價$４２８０
✨率性戶外慢跑鞋 #MTNTRMB4 下殺 $１９８４
✨熱銷系列玩轉新色 #ML373CO2 下殺$１６６６
✨必備經典復古 #ML574NR2 下殺$２１６０
日常時尚鞋款應有盡有😍一雙NB陪你歡喜迎新年 !

數量有限，售完為止`).substring(0, AdMainCopyLength)}
                <a href="#" onClick={handleClick}>....查看更多</a>
              </div>
            )}
            {(!showViewMore) && (
              <div className={Styles.contentSubHeaderTitle} style={(!showViewMore) ? { whiteSpace: 'pre-wrap' } : {}}>
                {!showExample && ad.mainCopy}
                {showExample && (`(文案範例預覽)
歡慶新年🎊New Balance品牌週🎊
【勁爆下殺全館５折起🔥】
新年穿新鞋！立刻下單去🛒https://lihi1.com/lxTq9

▼▼熱銷款限時超低價！超多優惠報你知▼▼
✨百搭復古運動鞋 #M5740TA 限搶價$４２８０
✨率性戶外慢跑鞋 #MTNTRMB4 下殺 $１９８４
✨熱銷系列玩轉新色 #ML373CO2 下殺$１６６６
✨必備經典復古 #ML574NR2 下殺$２１６０
日常時尚鞋款應有盡有😍一雙NB陪你歡喜迎新年 !

數量有限，售完為止`)}
              </div>
            )}
          </div>
          <div className={Styles.contentImageContainer}>
            {imageSource && <img className={Styles.contentImage} alt="" src={imageSource} />}
            {/* {videoSource && (
              <video className={Styles.contentVideo} autoPlay loop>
                <source src={videoSource} />
                {media.local?.name || media.prepopulated?.name || '影片'}
              </video>
            )} */}
            {videoSource && (
              <div className={Styles.contentVideoName}>{media.local?.name || media.prepopulated?.name || '影片'}</div>
            )}
          </div>
          {ad.platform === PlatformCategories.FacebookCarousel && (
            <>
              <div className={Styles.contentCtaContainer}>
                <div className={Styles.ctaPrice}>
                  <div>商品名稱</div>
                  <div>NT$399</div>
                </div>
                <div className={Styles.cta}>
                  {ad.cta}
                </div>
              </div>
              <div className={Styles.contentFacebookBar} />
            </>
          )}
          {ad.platform === PlatformCategories.FacebookFeatured && (
            <>
              <div className={Styles.contentDescription}>
                {!showExample && ad.title}
                {showExample && '歡慶新年🎊NB品牌週全館下殺５折起 !'}
              </div>
              <div className={Styles.contentButtons}>
                <div className={Styles.contentButton}>
                  賣場
                  <br />
                  產品圖
                </div>
                <div className={Styles.contentButton}>
                  賣場
                  <br />
                  產品圖
                </div>
                <div className={Styles.contentButton}>更多</div>
              </div>
            </>
          )}
          {ad.platform === PlatformCategories.FacebookReferral && (
            <>
              <div className={Styles.contentDescription}>
                {!showExample && ad.title}
                {showExample && '歡慶新年🎊NB品牌週全館下殺５折起 !'}
              </div>
              <div className={Styles.contentFacebookBar} />
            </>
          )}
          {ad.platform === PlatformCategories.FacebookImpression && (
            <>
              <div className={Styles.contentFacebookBar} />
            </>
          )}
        </div>
      </div>
      <div className={Styles.lowerContainer} />
    </div>
  );
}

PhonePreview.propTypes = {
  className: PropTypes.string,
  ad: PropTypes.instanceOf(Ad),
  media: PropTypes.object,
};

PhonePreview.defaultProps = {
  className: '',
  ad: new Ad(),
  media: { local: null, prepopulated: null },
};
